module.exports = __webpack_public_path__ + "static/media/ios-settings.975cb155.svg";